import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { authAPI } from "../services/api";
import { useAuth } from "../context/AuthContext";
import { notify } from "../utils/notify";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPwd, setShowPwd] = useState(false);
  const [showForgot, setShowForgot] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");
  const [forgotLoading, setForgotLoading] = useState(false);
  const [forgotSent, setForgotSent] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleForgotSubmit = async (e) => {
    e.preventDefault();
    if (!forgotEmail) {
      notify.warn("Please enter your email");
      return;
    }
    setForgotLoading(true);
    try {
      await authAPI.forgotPassword(forgotEmail.trim());
      setForgotSent(true);
    } catch (err) {
      notify.error(err.message || "Something went wrong. Please try again.");
    } finally {
      setForgotLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      notify.warn("Please enter email and password");
      return;
    }
    setLoading(true);
    try {
      const data = await authAPI.login(email.trim(), password);
      login(data.user, data.token);
      notify.success(`Welcome back, ${data.user?.userName || "User"}!`);
      navigate("/dashboard");
    } catch (err) {
      notify.error(err.message || "Invalid credentials. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const demos = [
    ["admin@tseenvironment.com", "Admin@1234", "Admin", "#7c3aed"],
    ["manager@tseenvironment.com", "Manager@1234", "Manager", "#1d4ed8"],
    ["hod@tseenvironment.com", "Hod@1234", "HOD", "#0f766e"],
    ["finance@tseenvironment.com", "Finance@1234", "Finance", "#b45309"],
    ["employee@tseenvironment.com", "Employee@1234", "Employee", "#16a34a"],
    [
      "procurement@tseenvironment.com",
      "Procurement@1234",
      "Procurement",
      "#dc2626",
    ],
  ];

  return (
    <div
      style={{
        minHeight: "100vh",
        background:
          "linear-gradient(135deg,#1e3a5f 0%,#1a5276 50%,#1e8449 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 20,
      }}
    >
      <div style={{ width: "100%", maxWidth: 440 }}>
        <form onSubmit={handleSubmit}>
          <div
            style={{
              background: "#fff",
              borderRadius: 20,
              padding: "32px 32px 28px",
              boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
            }}
          >
            <div className="text-center mb-3">
              <img className="mb-3" src="/assets/images/logo.png" width="180" />
              <div
                style={{
                  color: "#000000",
                  fontWeight: 700,
                  fontSize: "1rem",
                  letterSpacing: 0.5,
                }}
              >
                TSE WORKSPACE
              </div>
              <div
                style={{
                  color: "rgba(45, 45, 45, 0.65)",
                  fontSize: "0.78rem",
                }}
              >
                Integrated Management System
              </div>
            </div>

            <h5
              style={{
                fontWeight: 600,
                color: "#111827",
                marginBottom: 20,
                textAlign: "center",
                letterSpacing: -0.1,
              }}
            >
              Sign In to your account
            </h5>

            <div style={{ marginBottom: 16 }}>
              <label
                style={{
                  fontSize: "0.78rem",
                  fontWeight: 700,
                  color: "#374151",
                  display: "block",
                  marginBottom: 6,
                }}
              >
                Email ID
              </label>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  border: "1.5px solid #e5e7eb",
                  borderRadius: 10,
                  padding: "0 14px",
                  gap: 8,
                  background: "#f9fafb",
                }}
              >
                <i className="bi bi-person" style={{ color: "#9ca3af" }} />
                <input
                  type="email"
                  placeholder="mail@tseco.in"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  style={{
                    border: "none",
                    outline: "none",
                    background: "transparent",
                    padding: "11px 0",
                    fontSize: "0.88rem",
                    flex: 1,
                    color: "#111827",
                  }}
                />
              </div>
            </div>

            <div style={{ marginBottom: 20 }}>
              <label
                style={{
                  fontSize: "0.78rem",
                  fontWeight: 700,
                  color: "#374151",
                  display: "block",
                  marginBottom: 6,
                }}
              >
                Password
              </label>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  border: "1.5px solid #e5e7eb",
                  borderRadius: 10,
                  padding: "0 14px",
                  gap: 8,
                  background: "#f9fafb",
                }}
              >
                <i className="bi bi-lock" style={{ color: "#9ca3af" }} />
                <input
                  type={showPwd ? "text" : "password"}
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  style={{
                    border: "none",
                    outline: "none",
                    background: "transparent",
                    padding: "11px 0",
                    fontSize: "0.88rem",
                    flex: 1,
                    color: "#111827",
                  }}
                />
                <i
                  className={`bi ${showPwd ? "bi-eye-slash" : "bi-eye"}`}
                  style={{ color: "#9ca3af", cursor: "pointer" }}
                  onClick={() => setShowPwd((v) => !v)}
                />
              </div>
              <div style={{ textAlign: "right", marginTop: 8 }}>
                <button
                  type="button"
                  onClick={() => {
                    setForgotEmail(email);
                    setForgotSent(false);
                    setShowForgot(true);
                  }}
                  style={{
                    background: "none",
                    border: "none",
                    padding: 0,
                    color: "#1a5276",
                    fontSize: "0.78rem",
                    fontWeight: 600,
                    cursor: "pointer",
                  }}
                >
                  Forgot password?
                </button>
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              style={{
                display: "block",
                width: "100%",
                background: "linear-gradient(135deg,#1a5276,#1e8449)",
                color: "#fff",
                padding: "13px",
                borderRadius: 12,
                fontWeight: 700,
                fontSize: "0.95rem",
                border: "none",
                cursor: loading ? "not-allowed" : "pointer",
                opacity: loading ? 0.75 : 1,
              }}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" />
                  Signing In ...
                </>
              ) : (
                <>
                  <i className="bi bi-box-arrow-in-right me-2" />
                  Sign In
                </>
              )}
            </button>
          </div>
        </form>

        {showForgot && (
          <div
            className="modal show d-block"
            style={{ background: "rgba(0,0,0,0.55)" }}
            onClick={() => setShowForgot(false)}
          >
            <div
              className="modal-dialog modal-dialog-centered"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="modal-content shadow-lg" style={{ borderRadius: 16 }}>
                <div className="modal-header border-0">
                  <h5 className="fw-bold mb-0">
                    <i className="bi bi-key me-2 text-primary" />
                    Reset your password
                  </h5>
                  <button
                    className="btn-close"
                    onClick={() => setShowForgot(false)}
                  />
                </div>
                <div className="modal-body">
                  {forgotSent ? (
                    <div className="text-center py-2">
                      <i
                        className="bi bi-envelope-check"
                        style={{ fontSize: 40, color: "#16a34a" }}
                      />
                      <p className="mt-3 mb-0" style={{ fontSize: "0.9rem", color: "#374151" }}>
                        If an account exists for <b>{forgotEmail}</b>, we've
                        sent a password reset link to that email. The link is
                        valid for 1 hour.
                      </p>
                    </div>
                  ) : (
                    <form onSubmit={handleForgotSubmit}>
                      <p style={{ fontSize: "0.85rem", color: "#6b7280" }}>
                        Enter your account email and we'll send you a link to
                        reset your password.
                      </p>
                      <label className="form-label small fw-semibold">
                        Email ID
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="your@tseenvironment.com"
                        value={forgotEmail}
                        onChange={(e) => setForgotEmail(e.target.value)}
                        autoFocus
                      />
                      <button
                        type="submit"
                        disabled={forgotLoading}
                        className="btn w-100 mt-3 fw-semibold"
                        style={{
                          background: "linear-gradient(135deg,#1a5276,#1e8449)",
                          color: "#fff",
                          borderRadius: 10,
                          padding: "11px",
                          border: "none",
                        }}
                      >
                        {forgotLoading ? (
                          <span className="spinner-border spinner-border-sm" />
                        ) : (
                          <>
                            <i className="bi bi-send me-2" />
                            Send Reset Link
                          </>
                        )}
                      </button>
                    </form>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
        <div
          style={{
            textAlign: "center",
            marginTop: 16,
            color: "rgba(255,255,255,0.5)",
            fontSize: "0.75rem",
          }}
        >
          <i className="bi bi-shield-lock me-1" />© 2026 TSE Workspace —
          Secure Portal
        </div>
      </div>
    </div>
  );
}
export default Login;
